import { VStack, Heading, Text, Box, HStack, Badge } from '@chakra-ui/react'
import { Plug, Mail, Video, FileSignature } from 'lucide-react'

interface Integration {
  id: string
  name: string
  description: string
  icon: React.ElementType
  status: 'connected' | 'available' | 'coming_soon'
}

const integrations: Integration[] = [
  {
    id: 'ar24',
    name: 'AR24',
    description: 'Envoi de lettres recommandées électroniques (LRE/LRAR)',
    icon: Mail,
    status: 'available',
  },
  {
    id: 'visio',
    name: 'Visioconférence',
    description: 'Solution de visio intégrée pour les AG à distance',
    icon: Video,
    status: 'coming_soon',
  },
  {
    id: 'docuseal',
    name: 'DocuSeal / Docaposte',
    description: 'Signature électronique de documents',
    icon: FileSignature,
    status: 'coming_soon',
  },
]

export function IntegrationsPage() {
  return (
    <VStack align="stretch" gap={6}>
      {/* Header */}
      <VStack align="start" gap={2}>
        <HStack gap={2}>
          <Plug size={24} />
          <Heading as="h2" fontSize="2xl">
            Intégrations
          </Heading>
        </HStack>
        <Text color="gray.600">
          Connectez vos outils externes (AR24, visio, signature électronique...)
        </Text>
      </VStack>

      {/* Integrations List */}
      <VStack align="stretch" gap={4}>
        {integrations.map((integration) => {
          const Icon = integration.icon
          const statusConfig = {
            connected: { label: 'Connecté', color: 'green' },
            available: { label: 'Disponible', color: 'blue' },
            coming_soon: { label: 'Bientôt', color: 'gray' },
          }

          return (
            <Box
              key={integration.id}
              p={6}
              bg="white"
              borderRadius="lg"
              border="1px solid"
              borderColor="gray.200"
              opacity={integration.status === 'coming_soon' ? 0.6 : 1}
            >
              <HStack justify="space-between" align="start">
                <HStack gap={4} flex={1}>
                  <Box
                    p={3}
                    bg="gray.50"
                    borderRadius="lg"
                    color="gray.700"
                  >
                    <Icon size={24} />
                  </Box>
                  <VStack align="start" gap={1} flex={1}>
                    <Text fontWeight="semibold" fontSize="lg">
                      {integration.name}
                    </Text>
                    <Text fontSize="sm" color="gray.600">
                      {integration.description}
                    </Text>
                  </VStack>
                </HStack>
                <Badge
                  colorPalette={statusConfig[integration.status].color}
                  size="sm"
                >
                  {statusConfig[integration.status].label}
                </Badge>
              </HStack>
            </Box>
          )
        })}
      </VStack>

      {/* Info Box */}
      <Box
        p={6}
        bg="blue.50"
        borderRadius="lg"
        border="1px solid"
        borderColor="blue.200"
      >
        <VStack align="start" gap={2}>
          <Text fontWeight="medium" color="blue.900">
            💡 Besoin d'une intégration spécifique ?
          </Text>
          <Text fontSize="sm" color="blue.800">
            Contactez notre équipe pour discuter de vos besoins en intégrations tierces.
          </Text>
        </VStack>
      </Box>
    </VStack>
  )
}
